import { useEffect } from 'react';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';
import { Container } from '~/content/components/Container';

import { useTranslation } from 'react-i18next';
import Hero from './hero';
import HeroInfo from './heroInfo';
import Overview from './overview';
import Technologies from './technologies';
import Implementation from './implementation';
import Flow from './flow';
import References from './references';
import Achievements from './achievements';
import Conclusion from './conclusion';
import Contact from '~/content/components/Contact_redirect';
import { trackPageview } from '~/utils/plausible';
import { useTheme } from '@mui/material/styles';

const references = (): JSX.Element => {
	let { t } = useTranslation(['project_stk-website']);
	const theme = useTheme();

	const size = '3px';
	const gap = '16px';

	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	useEffect(() => {
		trackPageview();
	}, []);

	return (
		<Box>
			<Container>
				<Hero />
			</Container>

			<Box bgcolor={'alternate.main'}>
				<Container>
					<HeroInfo />
				</Container>
			</Box>

			<Container>
				<Overview />
			</Container>

			<Box bgcolor={'alternate.main'}>
				<Container>
					<Technologies />
				</Container>
			</Box>
			<Container>
				<Implementation />
			</Container>

			<Container>
				<Flow />
			</Container>

			<Container>
				<Achievements />
			</Container>

			<Box bgcolor={'alternate.main'} pt={{ xs: 0, md: 4 }} pb={{ xs: 0, md: 0 }}>
				<Container>
					<Conclusion />
				</Container>
			</Box>

			<Box bgcolor={'alternate.main'} pt={{ xs: 0, md: 0 }} pb={{ xs: 0, md: 4 }}>
				<Container>
					<References />
				</Container>
			</Box>

			<Box
				pt={{ xs: 5, md: 9 }}
				pb={{ xs: 5, md: 9 }}
				bgcolor={theme.palette.primary.light}
				sx={{
					position: 'relative',

					'&::after': {
						position: 'absolute',
						content: '""',
						// width: '25%',
						zIndex: 1,
						top: 0,
						width: isMd ? '25%' : '0%',
						left: '5%',
						height: '93%',
						inset: gap,
						WebkitMask: `
									conic-gradient(at ${size} ${size},#0000 75%,#000 0) 0 0,
									conic-gradient(at ${size} ${size},#0000 75%,#000 0) 0 0;
									`,
						WebkitMaskSize: `calc(${size} + ${gap}) calc(${size} + ${gap})`,
						background: theme.palette.primary.main,
						opacity: 0.1,
					},
				}}
			>
				<Container>
					<Contact leftButtonText={t('mini_contact_button_left')} leftButtonLink='websites/' />
				</Container>
			</Box>
		</Box>
	);
};
export default references;
